import { ClassesBuilder } from '@utilities';

const classesConfig = {
  mapContainer: 'aspect-video',
};

export default new ClassesBuilder(classesConfig);
